"use strict";

exports.__esModule = true;
exports.MeasureChartElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _scales = require("../../Charts/scales");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _createYScale = require("../common/AggregateMetricCharts/createYScale");
var _getTickXFormatter = require("../common/AggregateMetricCharts/getTickXFormatter");
var _getXValue = require("../common/AggregateMetricCharts/getXValue");
var _getYTickFormatter = require("../common/AggregateMetricCharts/getYTickFormatter");
var _getYValue = require("../common/AggregateMetricCharts/getYValue");
var _TimeseriesFixedWidthChart = require("../common/AggregateMetricCharts/TimeseriesFixedWidthChart");
var _WidgetLoadingSpinner = require("../common/WidgetLoadingSpinner");
var _dataFormatter = require("./dataFormatter");
var _MeasureChartDataProvider = require("./MeasureChartDataProvider");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MeasureChartElement = exports.MeasureChartElement = function MeasureChartElement(props) {
  var measureChartSeries = props.measureChartSeries,
    width = props.width,
    height = props.height,
    dataRange = props.dataRange,
    hideYLabel = props.hideYLabel,
    hideYAxis = props.hideYAxis,
    hideXAxis = props.hideXAxis,
    scatterPlotRadius = props.scatterPlotRadius;
  var _useSelectionContext = (0, _TimePeriodController.useSelectionContext)({
      dataRange: dataRange
    }),
    interval = _useSelectionContext.interval;
  if (measureChartSeries.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_styles.ErrorText, {
      width: width,
      height: height
    }, "Please select a measure");
  }
  var tickXFormatter = function tickXFormatter(tickXFormatterProps) {
    return (0, _getTickXFormatter.getXTickFormatter)(Object.assign({
      windowType: "timeseries"
    }, tickXFormatterProps));
  };
  return /*#__PURE__*/_react["default"].createElement(_MeasureChartDataProvider.MeasureChartDataProvider, {
    measureChartSeries: measureChartSeries,
    interval: interval
  }, function (_ref) {
    var fetching = _ref.fetching,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data;
    if (fetching) {
      return /*#__PURE__*/_react["default"].createElement(_WidgetLoadingSpinner.WidgetLoadingSpinner, {
        width: width,
        height: height
      });
    }
    var series = (0, _dataFormatter.getSeries)({
      data: data,
      measureChartSeries: measureChartSeries,
      interval: interval,
      scatterPlotRadius: scatterPlotRadius
    });
    var typeOfValues = series[0].data.map(function (_ref2) {
      var value = _ref2.value;
      return typeof value;
    });
    if (typeOfValues.includes("string")) {
      return /*#__PURE__*/_react["default"].createElement(_styles.ErrorText, {
        width: width,
        height: height
      }, "Selected Timeline/Measure is not supported in this widget");
    }
    return /*#__PURE__*/_react["default"].createElement(_TimeseriesFixedWidthChart.TimeseriesFixedWidthChart, {
      series: series,
      width: width,
      height: height,
      hideYUnits: hideYLabel,
      hideYAxis: hideYAxis,
      hideXAxis: hideXAxis,
      xScale: function xScale(from, to) {
        return (0, _scales.createIntervalScale)(from, to, interval);
      },
      yScales: _createYScale.createScatterPlotYScales,
      scrollable: false,
      useUnitAsLabel: true,
      hideXUnits: true,
      aggregateXAxis: false,
      tickXFormat: tickXFormatter,
      tickYFormat: _getYTickFormatter.getYTickFormatter,
      tooltipFormatters: {
        getXFormatter: _getXValue.getXValueInLinearScale,
        getYFormatter: _getYValue.getYValueForLinearData
      }
    });
  });
};